import React, { useMemo } from 'react';

import { useOrderDetailContext } from 'providers/OrderDetailProvider';
import { useUserContext } from 'providers/UserProvider';

import Table from 'components/common/Table';
import OrderReturnExpandedRow from 'components/add_order/order/OrderDetail/OrderReturns/OrderReturnExpandedRow';

import { shipmentApi } from 'api';
import { getOrderDetailReturnsColumns } from 'constants/order';

const OrderReturns = ({ orderId }) => {
  const { orderDetailData } = useOrderDetailContext();
  const { selectedTenant, selectedWarehouse } = useUserContext();
  const tenant = selectedTenant?.domains?.[0]?.domain;
  const warehouse = selectedWarehouse?.domain;

  const columns = useMemo(
    () => getOrderDetailReturnsColumns(tenant, warehouse),
    [tenant, warehouse],
  );

  return (
    <Table
      title={`Order #${orderDetailData?.channelOrderId} Returns`}
      apiService={shipmentApi}
      columns={columns}
      fetchConfig={{
        method: 'getReturns',
        enablePagination: true,
      }}
      resourceId={orderId}
      renderExpandedRow={row => (
        <OrderReturnExpandedRow shipment={row.original} />
      )}
    />
  );
};

export default OrderReturns;
